import { BaseApiOutput } from './base-api.model';
export class PlanDetailsApiOutput extends BaseApiOutput {
  public zuora_acct_key: string;
  public plan_user_limit: string;
  public plan_product_id: string;
  public plan_rate_plan_id: string;
  public plan_rate_plan_charge_id: string;
}

export enum PlanTerm {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}
